// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic"

export const components = {
  center_quote: dynamic(() => import("./CenterQuote")),
  contact_banner: dynamic(() => import("./ContactBanner")),
  csv: dynamic(() => import("./Csv")),
  cta_banner: dynamic(() => import("./CtaBanner")),
  faq: dynamic(() => import("./Faq")),
  hero: dynamic(() => import("./Hero")),
  how_it_works: dynamic(() => import("./HowItWorks")),
  icon_list: dynamic(() => import("./IconList")),
  icon_slider: dynamic(() => import("./IconSlider")),
  inline_image: dynamic(() => import("./InlineImage")),
  luggage_storage_newsletter_banner: dynamic(() => import("./LuggageStorageNewsletterBanner")),
  packages_app_demo_banner: dynamic(() => import("./PackagesAppDemoBanner")),
  packages_benefits: dynamic(() => import("./PackagesBenefits")),
  packages_city_slider: dynamic(() => import("./PackagesCitySlider")),
  packages_faq: dynamic(() => import("./PackagesFaq")),
  packages_hero: dynamic(() => import("./PackagesHero")),
  packages_how_it_works: dynamic(() => import("./PackagesHowItWorks")),
  packages_luggage_storage_product_banner: dynamic(() => import("./PackagesLuggageStorageProductBanner")),
  packages_pricing: dynamic(() => import("./PackagesPricing")),
  packages_reviews: dynamic(() => import("./PackagesReviews")),
  packages_stories_slider: dynamic(() => import("./PackagesStoriesSlider")),
  packages_ways_to_use: dynamic(() => import("./PackagesWaysToUse")),
  quote: dynamic(() => import("./Quote")),
  section: dynamic(() => import("./Section")),
  table: dynamic(() => import("./Table")),
  testimonial_logo_list: dynamic(() => import("./TestimonialLogoList")),
  testimonial_slider: dynamic(() => import("./TestimonialSlider")),
  text: dynamic(() => import("./Text")),
  text_block: dynamic(() => import("./TextBlock")),
}
